/* eslint-disable react/jsx-no-undef */
import React, { useEffect, useState, useRef } from 'react'
import Destination from '../hero/hero-rslhome/Destination'
import moment from 'moment'
import dayjs from 'dayjs'
import HotelCalanderFrom from '../hero/hero-rslhome/HotelCalanderFrom'
import GuestSearch from '../rental-list/common/GuestSearchHotels'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
// import HotelDestinationCity from "../hero/hero-rslhome/HotelDestinationCity";
// import HotelDestinationCity from "../hero/hero-rslhome/ActivityDestinationCityActivity";
import HotelDestinationCity from '../../components/hero/hero-rslhome/hotel/ActivityDestinationCityActivity'
import HotelDestinationCityHotel from '../../components/hero/hero-rslhome/hotel/ActivityDestinationCityActivityHotel'
import { useRouter } from 'next/router'
// Redux
import { useDispatch, useSelector } from '../../redux/store'

import {
  searchActivity,
  searchActivityList,
  getHotelCityList,
  searchHotelName
} from '../../redux/slices/hotel'
import CircularProgress from '@mui/material/CircularProgress'
import { createTheme, ThemeProvider } from '@mui/material/styles'

const customTheme = createTheme({
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#ffffff', // Change to your desired color
          width: '20px !important',
          height: '20px !important'
        }
      }
    }
  }
});

const HotelsRSL = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const autocompleteFirst = useRef()
  const autocompleteNext = useRef()
  const {
    searchActivityRes,
    searchActivityListRes,
    hotelCityList,
    getHotelName
  } = useSelector(state => state.hotel)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [countryValue, setCountryValue] = useState('')
  const currentDate = dayjs()
  const nextDay = currentDate.add(1, 'days') // Add 1 day
  const formattedDate = nextDay.format('YYYY-MM-DD')
  const formatcurrentDate = currentDate.format('YYYY-MM-DD')

  const [checkInDate, setCheckInDate] = useState(formatcurrentDate)
  const [checkOutDate, setCheckOutDate] = useState(formattedDate)
  const [loader, setLoader] = useState(false)
  const [loaderSearch, setLoaderSearch] = useState(false)
  const [guetsValue, setGuestValue] = useState({
    Adults: 1,
    Children: 0,
    Rooms: 1,
    ChildrenAges: []
  })

  const [cityValue, setCityValue] = useState([])
  const [cityValue1, setCityValue1] = useState([])

  const [searchProduct, setSearchProduct] = useState("")
  const [selectedValue, setSelectedValue] = useState({
    name: ''
  })
  const [searchProduct1, setSearchProduct1] = useState([])
  const [selectedValue1, setSelectedValue1] = useState({
    name: ''
  })
  const [childAge, setChildAge] = useState([])

  const [loading, setLoading] = useState(true)

  const [focusFirst, setFocusFirst] = useState(true)
  const [focusNext, setFocusNext] = useState(false)

  const [isSubmitClicked, setIsSubmitClicked] = useState(false)
  const [isFormValid, setIsFormValid] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')
  const [selectedCountry, setSelectedCountry] = useState({
    code: 'AE',
    label: 'United Arab Emirates',
    phone: '971',
    maxlength: '9'
  })
  const [selectedRating, setSelectedRating] = React.useState(null)
  const [selectedHotel, setSelectedHotel] = useState('')
  const [searchHotel, setSearchHotel] = useState('')

  const [additionalCounters, setAdditionalCounters] = useState([
    {
      name: 1,
      adults: 1,
      children: 0,
      childrenAges: [],
      Rooms: 1
    }
  ])

  useEffect(() => {
    if (autocompleteFirst.current) {
      autocompleteFirst.current
        .querySelector('input')
        .focus({ preventScroll: true })
    }
  }, [])

  useEffect(() => {
    if (selectedValue?.name !== '' && selectedValue !== null) {
      if (autocompleteNext.current) {
        autocompleteNext.current
          .querySelector('input')
          .focus({ preventScroll: true })
        setFocusNext(true)
      }
    }
  }, [selectedValue])

  useEffect(() => {
    setLoading(true)
    const timerId = setTimeout(() => {
      if (searchProduct.length >= 3) {
        dispatch(
          searchActivity({
            query: searchProduct.length > 0 ? searchProduct : ''
          })
        )
      } else if (searchProduct.length === 0) {
        dispatch(searchActivity({ query: '' }))
      }
    }, 500)

    return () => {
      clearTimeout(timerId)
    }
  }, [searchProduct])

  //   useEffect(() => {
  //     setLoading(true);
  //     dispatch(
  //       searchHotelName({ query: searchHotel , cityName : searchProduct })
  //     );

  // }, [searchHotel,searchProduct, dispatch]);

  useEffect(() => {
    if (searchActivityRes !== undefined) {
      const myObjectDestination = {}
      const childArrayDestination = []
      const myObjectActivityList = {}
      const childArrayActivityList = []
      const myObjectHotelList = {}
      const childArrayHotelList = []
      const mainArray = []
      if (searchActivityRes?.cityList !== undefined) {
        if (searchActivityRes?.cityList.length > 0) {
          searchActivityRes?.cityList.map(data => {
            myObjectDestination.label = 'City'
            myObjectDestination.img = '/img/general/flag.png'

            childArrayDestination.push(data)
            myObjectDestination.values = childArrayDestination
          })
        } else {
          myObjectDestination.label = 'City'
          myObjectDestination.values = []
        }
      }

      if (searchActivityRes?.countryList !== undefined) {
        if (searchActivityRes?.countryList.length > 0) {
          searchActivityRes?.countryList.map(data => {
            myObjectActivityList.label = 'country'
            myObjectActivityList.img = '/img/general/iconnew.png'
            childArrayActivityList.push(data)
            myObjectActivityList.values = childArrayActivityList
            //
          })
        } else {
          myObjectActivityList.label = 'country'
          myObjectActivityList.values = []
        }
      }

      if (searchActivityRes?.hotelList !== undefined) {
        if (searchActivityRes?.hotelList.length !== 0) {
          searchActivityRes?.hotelList.map(data => {
            myObjectHotelList.label = 'Hotels'
            myObjectHotelList.img = '/img/general/iconnew.png'
            childArrayHotelList.push(data)
            myObjectHotelList.values = childArrayHotelList
            //
          })
        } else {
          myObjectHotelList.label = 'Hotels'
          myObjectHotelList.values = []
        }
      }

      setLoading(false)
      mainArray.push(
        myObjectDestination,
        myObjectActivityList,
        myObjectHotelList
      )
      // mainArray.push(myObjectDestination);
      setCityValue(mainArray)
    }
  }, [searchActivityRes])

  // useEffect(() => {
  //   if (searchActivityListRes !== undefined) {
  //     const myObjectDestination = {};
  //     const childArrayDestination = [];
  //     const myObjectActivityList = {};
  //     const childArrayActivityList = [];
  //     const mainArray = [];
  //     if (searchActivityListRes?.topHotels !== undefined) {
  //       if (searchActivityListRes?.topHotels.length > 0) {
  //         searchActivityListRes?.topHotels.map((data) => {
  //           myObjectDestination.label = "Top Hotels";
  //           myObjectDestination.img = "/img/general/flag.png";

  //           childArrayDestination.push(data);
  //           myObjectDestination.values = childArrayDestination;
  //         });
  //       } else {
  //         myObjectDestination.label = "Top Attraction";
  //         myObjectDestination.values = [];
  //       }
  //     }

  //     if (searchActivityListRes?.hotelList !== undefined) {
  //       if (searchActivityListRes?.hotelList.length > 0) {
  //         searchActivityListRes?.hotelList.map((data) => {
  //           myObjectActivityList.label = "Hotels";
  //           myObjectActivityList.img = "/img/general/iconnew.png";
  //           childArrayActivityList.push(data);
  //           myObjectActivityList.values = childArrayActivityList;
  //           //
  //         });
  //       } else {
  //         myObjectActivityList.label = "Activities";
  //         myObjectActivityList.values = [];
  //       }
  //     }
  //     if (searchActivityListRes.hotelList.length === 0) {
  //       setSelectedValue1({
  //         name: ''
  //       })
  //     }
  //     setLoading(false);
  //     mainArray.push(myObjectDestination, myObjectActivityList);
  //     setCityValue1(mainArray);
  //   }

  // }, [searchActivityListRes]);

  useEffect(() => {
    setIsSubmitClicked(false)
    if (
      searchProduct &&
      searchProduct !== '' &&
      checkInDate &&
      checkInDate !== '' &&
      checkOutDate &&
      checkOutDate !== '' &&
      selectedCountry !== null
    ) {
      setIsButtonDisabled(false)
    } else {
      setIsButtonDisabled(true)
    }
  }, [searchProduct, checkInDate, checkOutDate, selectedCountry])

  // useEffect(() => {
  //   dispatch(getHotelCityList());
  // }, []);

  const handleBooking = () => {
    setLoader(true)

    router.push({
      pathname: '/hotels/hotels',
      query: {
        hotelCode: selectedValue1?.hotelCode,
        hotelId: selectedValue1?._id,
        hotel: searchProduct1,
        city: searchProduct,
        checkIn: checkInDate,
        checkOut: checkOutDate,
        GuestNationality: JSON.stringify(selectedCountry),
        Adults: guetsValue.Adults,
        Children: guetsValue.Children,
        Rooms: guetsValue.Rooms,
        additionalCounter: additionalCounters,
        // setPaxRooms:setAdditionalCounters,
        age: JSON.stringify(childAge)
        // time: moment(bookPickUpDate).format("YYYY-MM-DD hh:mm:ss A"),
      }
    })
  }

  const handleBookingSearch = () => {
    setIsSubmitClicked(true)
    if (selectedValue?.name && checkInDate !== '' && selectedCountry !== null) {
      setLoaderSearch(true)
      setLoader(true)
      sessionStorage.removeItem('hotel-session-end-time-new');
      sessionStorage.removeItem('hotel-session-end-time');
      sessionStorage.removeItem('session-end-time');
      router.push({
        pathname: '/hotels/hotels',
        query: {
          // hotelCode: selectedValue1?.hotelCode,
          hotelId: selectedValue?.group === 'Hotels' ? selectedValue?._id : '',
          // hotel: searchProduct1,
          city: searchProduct || '',
          checkIn: checkInDate,
          checkOut: checkOutDate,
          GuestNationality: JSON.stringify(selectedCountry),
          starRating: selectedRating ? selectedRating.label : '',
          hotelName: selectedHotel ? selectedHotel : '',
          Adults: guetsValue.Adults,
          Children: guetsValue.Children,
          Rooms: guetsValue.Rooms,
          additionalCounter: JSON.stringify(additionalCounters), // Include paxRooms here
          // setPaxRooms: 'true',
          age: JSON.stringify(childAge)
          // time: moment(bookPickUpDate).format("YYYY-MM-DD hh:mm:ss A"),
        }
      })
    } else {
      setIsFormValid(false)
      setErrorMessage('Please fill in all fields.')
    }
  }



  return (
    <>
      {/* <h4 className="text-15 fw-500 ls-2 lh-14 mb-20 text-black">
        Where Do You Want To Stay ?
      </h4> */}

      <div className='hotel-booking py-4'>
        <HotelDestinationCity
          setCityValue={setCityValue}
          cityValue={cityValue}
          searchProduct={searchProduct}
          setSearchProduct={setSearchProduct}
          setSelectedValue={setSelectedValue}
          selectedValue={selectedValue}
          // label="Select your City? *"
          label='Select your City, Hotel Or Location'
          placeholder='Search'
          setLoading={setLoading}
          loading={loading}
          autocompleteFirst={autocompleteFirst}
          error={isSubmitClicked && !selectedValue?.name}
          helperText={isSubmitClicked && !selectedValue?.name ? 'Required' : ''}
        />
        <div>
          <HotelCalanderFrom
            setCheckInDate={setCheckInDate}
            setCheckOutDate={setCheckOutDate}
            checkInDate={checkInDate}
            checkOutDate={checkOutDate}
            error={isSubmitClicked && checkInDate === '' ? true : false}
            helperText={isSubmitClicked && checkInDate === '' ? 'Required' : ''}
          />
        </div>
        <div className='d-flex items-center booking-guest-search'>
          <GuestSearch
            className='guest-search'
            additionalCounters={additionalCounters}
            setAdditionalCounters={setAdditionalCounters}
            setGuestValue={setGuestValue}
            guetsValue={guetsValue}
            setChildAge={setChildAge}
            childAge={childAge}
          // error={isSubmitClicked&&selectedValue?.name === '' ? true : false}
          // helperText={isSubmitClicked && selectedValue?.name === '' ? 'Required' : ''}
          />
        </div>

        <ThemeProvider theme={customTheme}>
          <button
            className='mainSearch__submit btn-1 button -dark-4 py-10 px-15  bg-dark-3 text-white w-100'
            onClick={handleBookingSearch}
          >
            {loader ? <CircularProgress /> : 'Search'}
          </button>
        </ThemeProvider>
      </div>
      <div className='booking-btns'>

        <div></div>
        <div className='trip-booking__btn'>

        </div>
      </div>
    </>
  )
}

export default HotelsRSL
